export class SpinningWheelItemModel {
    constructor(label, event, category) {
        this.label = label;
        this.event = event;
        switch (category) {
            case SpinningWheelCategory.BAD:
                this.color = "#000";
                break;
            case SpinningWheelCategory.LUCKY:
                this.color = "#F7931D";
                break;
            case SpinningWheelCategory.UNLUCKY:
                this.color = "#3D183D";
                break;
            default:
                this.color = "#F7931D";
                break;
        }
    }
}
export var SpinningWheelCategory;
(function (SpinningWheelCategory) {
    SpinningWheelCategory[SpinningWheelCategory["LUCKY"] = 0] = "LUCKY";
    SpinningWheelCategory[SpinningWheelCategory["UNLUCKY"] = 1] = "UNLUCKY";
    SpinningWheelCategory[SpinningWheelCategory["BAD"] = 2] = "BAD";
})(SpinningWheelCategory || (SpinningWheelCategory = {}));
